module.exports = __webpack_public_path__ + "static/media/image7_eng.cb958ba3.png";